module.exports = __webpack_public_path__ + "static/media/listDashes.21633ba7.svg";